import { ADDBOOKING, DELETEBOOKING } from './actionTypes';

const initialState = {
  booking: [],
};

const bookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADDBOOKING:
      const booking = [...state.booking];
      console.log(booking.length);
      if (booking.length <= 2) {
        booking.push(action.payload);
      }
      return {
        ...state,
        booking: [...booking],
      };
    case DELETEBOOKING:
      return {
        ...state,
        booking: [...state.booking].filter(
          (item) => item.id !== action.payload
        ),
      };

    default:
      return state;
  }
};

export default bookingReducer;
